import BaseModel from 'src/model/base.model';

class CreditCardIframeModel extends BaseModel {
  public sessionID: string;
  public url: string;
}

export default CreditCardIframeModel;
